import { AssetTypes } from "./types";
import {
  CANVAS_ROUTE,
  CHATBOT_ROUTE,
  INTERFACE_ROUTE,
  TABLE_ROUTE,
  EDITOR_ROUTE,
  AGENT_ROUTE,
} from "./constants";

export const getBuildAssetUrl = (
  assetType: AssetTypes,
  assetId: string | number,
) => {
  switch (assetType) {
    case AssetTypes.Zap: {
      return `${EDITOR_ROUTE}${assetId}`;
    }
    case AssetTypes.Interface: {
      return `${INTERFACE_ROUTE}/${assetId}`;
    }
    case AssetTypes.Table:
    case AssetTypes.TableView: {
      return `${TABLE_ROUTE}/t/${assetId}`;
    }
    case AssetTypes.Chatbot: {
      return `${CHATBOT_ROUTE}${assetId}`;
    }
    case AssetTypes.Canvas: {
      return `${CANVAS_ROUTE}${assetId}`;
    }
    case AssetTypes.Agent: {
      return `${AGENT_ROUTE}${assetId}/settings`;
    }
    default: {
      return "";
    }
  }
};
